import { Component, Inject } from '@angular/core';
import { DialogData } from '../dialog.models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-dialog-prompt',
	templateUrl: './dialog-prompt.component.html',
	styleUrls: ['./dialog-prompt.component.scss']
})
export class DialogPromptComponent {
	inputValue: string = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
		public dialogRef: MatDialogRef<DialogPromptComponent>
	) {}
}
